export enum DataDestination {
	console,
	localStorage,
	// localStorage,
	store
}
